import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign, Targeting } from '@feathr/blackbox';
import { CardV2 as Card } from '@feathr/components';
import {
  AgeDemographics,
  Interests,
  Locations,
  SelectedTargetings,
} from '@feathr/extender/components/Targetings';
import type { ListResponse } from '@feathr/rachis';

import * as styles from './AdWizardFiltersStep.css';

interface IProps {
  campaign: Campaign;
  targetings: ListResponse<Targeting>;
}

function AdWizardFiltersStep({
  campaign,
  targetings: targetingsList,
}: Readonly<IProps>): JSX.Element {
  const { isOmniCampaign } = campaign;
  const targetings = targetingsList.models;
  const { t } = useTranslation();

  return (
    <Flex
      className={styles.root}
      data-name={'filters_step'}
      justify={isOmniCampaign ? 'space-between' : 'center'}
    >
      {isOmniCampaign ? (
        <>
          <div className={styles.left}>
            <Locations campaign={campaign} targetings={targetings} />
            <AgeDemographics campaign={campaign} targetings={targetings} />
            <Interests campaign={campaign} targetings={targetings} />
          </div>

          <div className={styles.right}>
            <Card>
              <Card.Header title={t('Selected Filters')} />
              <Card.Content addVerticalGap={true}>
                <SelectedTargetings targetings={targetingsList} />
              </Card.Content>
            </Card>
          </div>
        </>
      ) : (
        <Locations campaign={campaign} targetings={targetings} />
      )}
    </Flex>
  );
}

export default observer(AdWizardFiltersStep);
